export const esList = [
  {
    "esName": "厦门凤凰创壹软件有限公司",
    "esProvince": "厦门市",
    "esDesc": "厦门凤凰创壹软件有限公司隶属于凤凰出版传媒集团，主要致力于VR/AR/MR仿真软件平台的研制、开发、运用与推广。凤凰创壹积累超过25年国内外先进的虚拟现实核心技术的科研经验，以英国、新加坡各大院校及相关研究机构的技术背景为依托，拥有完全自主知识产权的创壹跨平台虚拟现实VR/AR/MR引擎、浏览器、编辑工具、物理属性引擎、仿真教学云平台、智能化教学评价平台等产品。创壹技术具有三维模型数据量小（比其他3D模型数据量小100倍）、速度快、互动性强的特点，满足移动学习快速下载、快速更新的要求。经过凤凰创壹团队长期努力，公司已经发展成为中国虚拟现实VR/AR/MR仿真软件核心技术领军企业，产品技术获得客户的高度肯定，成为教育部职教所选定的三维互动教学软件开发、制作、",
    "esType": "互联网企业",
    "isInZjyd": 0,
    "esLogo": "Frame 2815.jpg",
  },
  {
    "esName": "首都信息发展有限公司",
    "esProvince": "北京市",
    "esDesc": "首都信息发展股份有限公司作为北京国资体系内电子政务领域的龙头企业，凭借首都政务信息化服务的丰富经验及信息资源优势，承担并完成了多项北京市乃至全国重大信息化应用工程建设、运营和维护工作，为“数字北京”和“智慧北京”建设作出突出贡献。首都信息下属首信学院拥有一支由美国圣荷塞州立大学12位“客座教授”和外聘专家、老师以及内训师组成的强大师资队伍，并有针对性地设计了入职培训、企业管理、专业技能、职业素养等4大类、百余门精品课程。",
    "esType": "互联网企业",
    "isInZjyd": 0,
    "esLogo": "Frame 2812.jpg",
  },
  {
    "esName": "人大数字科技有限公司",
    "esProvince": "北京市",
    "esDesc": "“‘职教学苑’创新教育工程”，是依托中国人民大学的优势学科与中国人民大学出版社的优势教学资源，围绕经济、法律、教育、工商管理、档案信息、新闻传播等学科专业，建立包含入职技能培训、职业资格证考试培训、从业人员继续教育课程以及职业能力测评系统的全流程教育服务体系,人大芸窗职教学苑是具体实施平台",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2813.jpg",
  },
  {
    "esName": "北京市空越技术有限公司",
    "esProvince": "北京市",
    "esDesc": "北京市空越技术有限公司正式成立于2006年6月，是一家专注于P2P、CDN等互联网流媒体数据传输分发技术的高科技公司，致力于为客户提供全球领先的、运营级的P2P流媒体系统。公司总部坐落于北京中关村高科技园区,在广州设有分公司。技术是空越公司的核心竞争力，经过长期的技术积累与沉淀，公司对于P2P流媒体技术的研究与开发处于国内领先地位。公司拥有独立创新的，完全自主开发并具有核心算法的多项软件产品，涵盖互联网流媒体数据传输的多个环节，可以很好的满足互联网的各项视频应用需求，具备提供完整的、端到端的解决方案的技术能力。目前，公司拥有五大系列产品：运营级的P2P流媒体直播系统、运营级的P2P流媒体点播系统、短视频加速下载播放系统、流媒体内容管理以及运营支撑系统（CMS+BOSS）、全球领先的基于P2P技术的软件CDN系统。可为电信、广电、新媒体、大型国企、政府、视频分享网站、远程教育网站等客户提供专业的综合解决方案。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2814.jpg",
  },
  {
    "esName": "深圳国泰安教育技术有限公司",
    "esProvince": "广东省",
    "esDesc": "深圳国泰安集团成立于2000 年，以创新教育技术、提升教育质量、回归教育本源为宗旨，聚焦职业教育领域，为院校提供以A/VR、AI 技术为支撑、以“教学- 实训- 管理- 评价”为核心的智慧教育综合解决方案，是“国家级高新技术企业”“国家火炬计划重点高新技术企业”“国家规划布局内重点软件企业”以及教育部“产学合作协同育人项目”支持企业。自成立以来，国泰安累计获得专利及著作权千余项，优质的产品与服务遍及20 多个国家和地区的3000 多家客户（包括国内1000 多所职业院校），赢得美国、俄罗斯、白罗斯、泰国、马来西亚等一带一路沿线国家的高度认可和海内外客户的一致好评。经过近二十年的发展，国泰安已成为中国职业教育服务领域的创新推动者与产教融合发展服务者。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2825.jpg",
  },
  {
    "esName": "北京润尼尔网络科技有限公司",
    "esProvince": "北京市",
    "esDesc": "北京润尼尔网络科技有限公司于2007年12月成立，注册资本2206万，是一家在北京海淀文教产业园注册的国家高新技术企业，总部位于北京，目前在武汉、西安、上海、成都、广州、南京、合肥、呼和浩特、哈尔滨等地设立了分支机构。润尼尔以虚拟仿真技术和网络技术为依托，主要从事教育教学系统的研究、开发、销售、集成和服务，可为学校的虚拟仿真实验教学、实验教学中心信息化以及VR相关专业人才培养提供一体化建设方案。公司现有全职员工530余人，研发力量占比60%以上，获得软件著作权300余项。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2819.jpg",
  },
  {
    "esName": "江西科骏实业有限公司",
    "esProvince": "江西省",
    "esDesc": "江西科骏实业有限公司是总部落地江西南昌的一家以计算机图像系统研发及VR教育及行业应用解决方案为主的技术服务企业，目前为国家高新技术、双软认证企业。科骏基于大数据、云计算、人工智能、AR/VR等技术，通过对“AI+VR+教育”智慧教育模式的探究与摸索，为基础教育、职业教育、高等教育等各阶段客户提供教育信息化服务，并为轨道交通、航空、汽车、智能制造及文化娱乐等行业领域提供定制化系列应用解决方案。公司目前拥有全球各地的高精尖技术人才200余名，在美国、深圳，昆明设立技术分中心。在VR教育市场不仅有完整的多元化AR/VR基础硬件，同时提供各内容系统集成和解决方案，在2019年评为：2018年度的江西省VR行业种子独角兽企业、2018年江西省功勋企业。目前科骏VR创新教室已覆盖全国21个省市地区，教育应用学校超过1300所。2017年参与教育部产学合作协同育人项目，在2018年被工信部考试中心授予通信信号专业技术资质认证企业，并为中国通号、中国中车、南昌地铁等行业企业进行人才培养认定，同时，在2019年与中国铁总正式开展人才培训合作。科骏秉承“让计算机看懂世界”的愿景，始终坚持市场化战略，借助信息强大的5G+VR教育平台资源，聚焦技术创新和行业应用，不断拓宽应用深度，致力成为中国VR教育卓越品牌。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2817.jpg",
  },
  {
    "esName": "武汉湾流科技股份有限公司",
    "esProvince": "湖北省",
    "esDesc": "“公司2015年度新三板挂牌，是华中地区第一家专注VR+行业应用的高科技企业（股票简称：湾流股份，股票代码：833549）。公司为湖北省虚拟现实（VR）应用工程技术研究中心、国家高新技术企业、湖北省隐形冠军培育企业、湖北名牌产品、湖北省科学进步奖荣誉企业，已通过CMMI-L5、ISO9001、GJB9001、ISO27001、ISO20000等体系认证，获得了《装备承制单位注册证书》、《武器装备科研生产单位二级保密资质证书》；公司研发力量雄厚，拥有自主研发的知识产权成果一百余项，其中已申报及授权发明专利16项。公司在VR+职业教育、VR+医学医疗、喷涂机器人、湾流一驾通、VR+安全教育及VR+军事国防六大领域布局发展。其中，VR+职业教育、VR+医学医疗处于国内一流水平，产品如VR+焊接、VR+喷涂、综合穿刺模拟器等都已居于国内市场领先地位；喷涂机器人以“PaintGo”品牌为依托，开拓布局喷涂服务机器人领域全国市场；湾流一驾通为提升传统驾培行业的一种新型商业运营平台，平台面向全国,已在湖北工业大学等安全教育基地进行推广；VR+安全教育、VR+军事国防市场呈现出快速发展势头。VR+安全教育、VR+军事国防市场呈现出快速发展势头。武汉湾流科技股份有限公司以VR+行业应用和机器视觉为技术发展依托，致力于为国内外客户提供专业的技能训练产品、服务及整体解决方案。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2823.jpg",
  },
  {
    "esName": "上海景格科技股份有限公司",
    "esProvince": "上海市",
    "esDesc": "景格科技创办于2003年，公司致力成为职业教育服务产业链的引领者。一直专注于职业教育，以汽车专业为起点，不断拓展交通运输类（轨道交通、工程机械、港口机械）、智能制造类（机器人、自动化、数控）等专业领域；以智慧教育为核心，围绕职业院校专业建设需求，提供专业咨询、课程建设、实训中心建设、师资队伍建设、教学评价、创新创业、产教融合等服务。景格科技多年来凭借卓越的创新能力、精湛的专业技术、高效的管理服务及优秀的企业文化，在业内形成良好口碑！2014年公司在新三板成功挂牌〔股票代码：430638〕，是一家具有核心竞争力的高新技术公众企业。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2822.jpg",
  },
  {
    "esName": "塔普翊海（上海）智能科技有限公司",
    "esProvince": "上海市",
    "esDesc": "RealMax塔普翊海（上海）智能科技有限公司是全球AR（增强现实）科技的领军企业，成立于2003年，中文名称为塔普翊海（上海）智能科技有限公司。总部设在上海，在北京、成都、西安、香港、纽约、芬兰建立了直辖子公司，是一家增强现实技术的国际生态级企业。 在工业市场，RealMax通过创新技术针对行业痛点提出了全方位的解决方案。产品旨在解放双手、保证现场安全、方便远程指导及大数据传输，进一步从高效、安全、数据化等方面来实现“智能制造2025”的目标。 在教育市场，公司13年来专注于将大数据、物联网、3D打印、无人机、智能制造和机器人等前沿技术产品转化为可以学以致用的教学资源，在中国教育市场积累了丰富的经验，已为700余所高校提供了优质服务。 在其它市场上，例如旅游、文创、医疗、安防、娱乐、电子商务、影视和游戏等，RealMax致力于将成熟的AR技术转化成垂直领域的商业化AR产品，帮助合作伙伴进行技术和产",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2827.jpg",
  },
  {
    "esName": "上海明材教育科技有限公司",
    "esProvince": "上海市",
    "esDesc": "上海明材教育是为解决产业升级下高素质技能人才培养难题而专门成立的教育科技公司，与清华、中科院、交大、同济、中电、中控、徐工、中国工业互联网研究院、工赋学院、工信部电子一所等单位达成战略合作，依托深厚行业、产业资源和参与工信部标准制定的优势，围绕制造业人才培养需求，创新人才培养模式，以提升高素质技术技能型人才培养质量为目标，将始终致力于“引进先进工业标准，整合优质企业资源，示范引领工程教育，定制培养专业人才”，为“中国制造2025”重大战略的实施提供有力的人才支撑！",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2826.jpg",
  },
  {
    "esName": "上海影创信息科技有限公司",
    "esProvince": "上海市",
    "esDesc": "影创科技集团成立于2014年8月，是国内第一、世界一流的混合现实行业领军企业，主要业务为混合现实、人工智能、半导体领域基础科学与应用技术及产品的研发。集团总部位于上海，在青岛、北京、重庆、成都、南昌、南京等多地设有产业基地，研发及生产场所占地面积超过2万平方米，实现全产业链布局，形成闭环生态。影创致力于对未来的探索，在2016年成立了量子机器学习实验室，主要从事人工智能技术的研究，2019年被正式授牌“浦东新区企业博士后科研工作站”； 与复旦大学微电子学院建立复旦-影创光芯片联合研究中心，强强联合共同开发国产光学芯片EDA软件。影创科技是高通集团在XR（扩展现实）行业全球最大的客户与技术合作伙伴之一。集团与中国移动、中国联通、中国电信三大运营商均达成合作，是中国移动“5G终端先行者产业联盟”、中国联通5G创新中心、中国电信智慧家庭生态圈重要成员。影创科技致力于用科技提高人们的生产效率，改变人们的生活方式，成为世界第一的MR公司。",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "Frame 2821.jpg",
  },
 
  {
    "esName": "北京中科旅信息技术研究院有限公司",
    "esProvince": "北京市",
    "esDesc": "北京中科旅信息技术研究院有限公司办公室地址位于中国的首都，政治、文化中心北京，北京 北京市昌平区回龙观镇金燕龙大厦12层1209，于2015年04月22日在昌平分局注册成立，注册资本为100 万元 人民币，在公司发展壮大的5年里，我们始终为客户提供好的产品和技术支持、健全的售后服务，我公司主要经营工程技术研究与试验发展；软件开发；零售计算机、软件及辅助设备；技术开发、技术转让、技术咨询、技术服务；计算机系统服务；基础软件服务、应用软件服务（不含医用软件）；投资咨询、经济贸易咨询、教育咨询、企业策划、企业管理咨询（不含中介服务）；公共关系服务；会议服务、承办展览展示；投资管理、资产管理；",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "",
  },
  {
    "esName": "邦锐亿得（北京）科技有限责任公司",
    "esProvince": "北京市",
    "esDesc": "邦锐亿得科技公司用科技力量优化产业结构，致力于科技教育的线上和线下结合，充分发挥资源整合优势，减少行业产品的同质化，拓展符合国内实际需求的新课题。公司使命：从科技产品打造入手，提供教育行业课程制作技术、题库建设、网校咨询等行业服务，为教育机构提供专业的学习产品，减少产品制作成本，大大降低合作单位的前期投入和发展风险。切实有效的学习方法，致力于实现服务行业的科技教育梦！业务体系：为满足行业及社会人群的需求，企业以亿得教育品牌为中心打造",
    "esType": "互联网企业",
    "isInZjyd": 1,
    "esLogo": "",
  },
];

